import script from "./FloatingIsland.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatingIsland.vue?vue&type=script&setup=true&lang=ts"

import "./FloatingIsland.vue?vue&type=style&index=0&id=3ef30fdb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef30fdb"]])

export default __exports__